<template>
  <div>
    <Header />
    <div :style="{ marginTop }">
      <router-view></router-view>
    </div>
    <Footer />
    <Alert />
    <Message />
  </div>
</template>

<script>
import Footer from "./layout/Footer.vue";
import Header from "./layout/Header.vue";
import Alert from "@components/Alert.vue";
import Message from "@components/Message.vue";

export default {
  components: {
    Alert, // 全局确认提示弹窗组件
    Message, // 全局消息弹窗组件
    Footer,
    Header,
  },
  data() {
    return {};
  },
  computed: {
    marginTop() {
      if (this.$route.path == "/index") return "117px";
      return "91px";
    },
  },
};
</script>